import { Injectable } from '@angular/core';
import { AppEventService, DataCacheService, RestDataService, UserService, UtilsService } from 'pumpcalc-core';
import { environment } from '../environments/environment';
import { PumpListService } from './pump-list.service';
import { PumpsetListService } from './pumpset-list.service';
import { FieldChanger, NodeNamer, TreeListService } from './tree-list.service';

export enum BuilderList {
  Pumpset="Pumpset",
  Booster="Booster",
  Custom_Pumpset="Custom Pumpset",
  Backing_Pump="Backing Pump",
  Drive="Drive"
}


@Injectable({
  providedIn: 'root'
})
export class ListLoaderService {

  pumpsetsNodeNamers:NodeNamer[] = [
    {getNodeName: (obj: any) => {
      return "Official";
    }},
    {getNodeName: (obj: any) => {
      return obj.division[0];
    }},
    {getNodeName: (obj: any) => {
      return obj.name.substr(0,3);
    }},
  ]

  customPumpsetsNodeNamers:NodeNamer[] = [
    {getNodeName: (obj: any) => {
      return "My Pumpsets";
    }},
  ]

  familyNodeNamers:NodeNamer[] =[
    {getNodeName: (obj: any) => {
      return obj.name.substr(0,2);
    }},
  ]

  fieldChanger:FieldChanger = {
    changeNames: (obj: any):any => {
      obj.text=obj.name;
      return obj;
    }
  }

  customPumpsetfieldChanger:FieldChanger = {
    changeNames: (obj: any):any => {
      obj.text=obj.name;
      obj.isUser=true;
      return obj;
    }
  }

  boosterNodeNamers:NodeNamer[] =[
   {getNodeName: (obj: any) => {
      let name=obj.name.substr(0,2);
      let boosterFamilies=["GXB","EH","XH","IH","HV","GMB"];
      boosterFamilies.forEach(boosterFamily=>{
        if(obj.name.substr(0,3).indexOf(boosterFamily)!=-1){
          name=boosterFamily;return;
        }
      })
      return name;
    }},
  ]

  driveNodeNamers:NodeNamer[] =[
    {getNodeName: (obj: any) => {
       let name=obj.name.substr(0,2);
       let boosterFamilies=["GXB","EH","XH","IH","HV","GMB"];
       boosterFamilies.forEach(boosterFamily=>{
         if(obj.name.substr(0,3).indexOf(boosterFamily)!=-1){
           name=boosterFamily;return;
         }
       })
       return name;
     }},
   ]

  constructor(
    private restDataService:RestDataService,
    private dataCacheService:DataCacheService,
    private treeListService:TreeListService,
    private appEventService:AppEventService,
    private userService:UserService,
    private utils:UtilsService,
    private pumpListService:PumpListService,
    private pumpsetListService:PumpsetListService) {
      appEventService.events.subscribe(event=>{
        if(event.name=="SAVED"){this.reloadCustomPumpsetList()}
      })
    }

  loadLists(){
    this.restDataService.get(environment.pumpSetsURL).subscribe((officalPumpsets:any[])=>{
      // let pumpsetsTree = this.treeListService.getTree(officalPumpsets,this.fieldChanger,this.pumpsetsNodeNamers);
      let pumpsetsTree = this.pumpsetListService.getPumpsetTreeList(officalPumpsets);
      let customPumpsetsTree;
      this.restDataService.get(this.restDataService.addIdToURL(this.userService.getUserId(),environment.customPumpSetsURLForUser)).subscribe((customPumpsets:any[])=>{
        customPumpsetsTree = this.treeListService.getTree(customPumpsets,this.customPumpsetfieldChanger,this.customPumpsetsNodeNamers);
        if(customPumpsetsTree[0]){customPumpsetsTree[0].items.reverse();}
        this.dataCacheService.put(BuilderList.Custom_Pumpset,customPumpsetsTree);
        pumpsetsTree = pumpsetsTree.concat(customPumpsetsTree);
        this.dataCacheService.put(BuilderList.Pumpset,pumpsetsTree);
        this.checkAllLoadedAndAnnounce();
      })
    });
    this.restDataService.get(environment.backingPumpsURL).subscribe((data:any[])=>{
      let pumpsTree = this.pumpListService.getPumpTreeList(data);
      this.dataCacheService.put(BuilderList.Backing_Pump,pumpsTree);
      this.checkAllLoadedAndAnnounce();
    });
    this.restDataService.get(environment.boostersURL).subscribe((data:any[])=>{
      this.dataCacheService.put(BuilderList.Booster,this.treeListService.getTree(data,this.fieldChanger,this.boosterNodeNamers));
      this.checkAllLoadedAndAnnounce();
    });
    this.restDataService.get(environment.drivesURL).subscribe((data:any[])=>{
      this.dataCacheService.put(BuilderList.Drive,this.treeListService.getTree(data,this.fieldChanger,this.familyNodeNamers));
      this.checkAllLoadedAndAnnounce();
    });
  }

  reloadCustomPumpsetList(){
    this.restDataService.get(this.restDataService.addIdToURL(this.userService.getUserId(),environment.customPumpSetsURLForUser)).subscribe((customPumpsets:any[])=>{
      let customPumpsetsTree:any[] = this.treeListService.getTree(customPumpsets,this.customPumpsetfieldChanger,this.customPumpsetsNodeNamers);
      let pumpsetsTree=this.dataCacheService.get(BuilderList.Pumpset);
      this.dataCacheService.put(BuilderList.Custom_Pumpset,customPumpsetsTree);
      if(customPumpsetsTree[0]){customPumpsetsTree[0].items.reverse();}
      pumpsetsTree[1]=customPumpsetsTree[0];
      this.dataCacheService.put(BuilderList.Pumpset,pumpsetsTree);
    })
  }

  checkAllLoadedAndAnnounce(){
    if(this.dataCacheService.get("Pumpset")&&this.dataCacheService.get("Backing Pump")&&this.dataCacheService.get("Booster")&&this.dataCacheService.get("Drive")){
      this.appEventService.emit({name:"CACHE_LOADED",context:""});
    }
  }

}
